import "./CondoAdmin.css";
import CondoDashboardAdmin from "./CondoDashboardAdmin";

const CondoAdminDashboard = () => {
  return (
    <>
      {/* <CondoAdminNavbar /> */}
      <div className="condo-admin-dashboard-pg">
        <div className="container">
          <div className="row">
            <CondoDashboardAdmin />
            {/* <div className="banner-condo-dashboard"></div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CondoAdminDashboard;
